import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import PageHero from "../components/PageHero";
import { TextLink } from "../components/Bits";
import { ROUTES } from "../lib/seo";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page not found — Antara Bhajan Jamming</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <PageHero
        eyebrow="404"
        title={<>This page went <span className="gold-grad italic">quiet</span></>}
        intro="We couldn't find that page. It may have moved, or never existed."
      >
        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2">
          <Link to={ROUTES.home.path} className="font-body text-sm" style={{ color: "#E5C880" }}>Home</Link>
          <Link to={ROUTES.pillar.path} className="font-body text-sm" style={{ color: "#E5C880" }}>What is bhajan jamming?</Link>
          <Link to={ROUTES.delhi.path} className="font-body text-sm" style={{ color: "#E5C880" }}>The Delhi edition</Link>
        </div>
      </PageHero>
      <section className="bg-cream py-20 px-6">
        <p className="max-w-2xl mx-auto text-center font-body text-ink-2/80">
          Try the <TextLink to={ROUTES.editions.path}>editions archive</TextLink> or head back{" "}
          <TextLink to={ROUTES.home.path}>home</TextLink>.
        </p>
      </section>
    </>
  );
}
